<template>
    <div ref="item" class="section-item" :style="itemStyle">
        <div ref="label" :class="labelClassObject" :style="labelStyle">{{ label }}</div>
        <div ref="content" :class="contentClassObject" :style="contentStyle">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SySectionItem',
    inject: {
        section: {
            from: 'section',
            default: null
        },
        sectionGroup: {
            from: 'sectionGroup',
            default: null
        }
    },
    props: {
        /**
         * 标签
         */
        label: {
            type: String,
            default: ''
        },
        /**
         * 标签类
         */
        labelClass: {
            type: String,
            default: ''
        },
        /**
         * 内容类
         */
        contentClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 子项间距
            colGap: 0,
            // 子项行间距
            rowGap: 0,
            // 子项宽度
            itemWidth: 0,
            // 标签宽度
            labelWidth: 0,
            // 内容宽度
            contentWidth: 0
        };
    },
    computed: {
        /**
         * item是否在group中
         */
        isInGroup() {
            if (this.sectionGroup) {
                return true;
            }

            return false;
        },
        /**
         * label是否在顶部
         */
        isTop() {
            return this.section.labelPosition === 'top';
        },
        /**
         * 是否自动宽度
         */
        isAutoWidth() {
            return this.section.itemWidth === 'auto';
        },
        /**
         * item样式对象
         */
        itemStyle() {
            const style = {
                'align-items': this.isTop ? 'flex-start' : this.section.labelAlign,
                'flex-direction': this.isTop ? 'column' : 'row'
            };

            if (!this.isInGroup) {
                style.width = this.isAutoWidth ? 'auto' : this.section.itemWidth;
                style.marginRight = `${this.colGap}px`;
                style.marginBottom = `${this.rowGap}px`;
            }
            return style;
        },
        /**
         * 标签样式对象
         */
        labelStyle() {
            const marginValue = `${this.section.maxLabelWidth - this.labelWidth}px`;
            const marginProp = this.section.labelPosition === 'left' || this.isTop ? 'marginRight' : 'marginLeft';
            return {
                [marginProp]: marginValue
            };
        },
        /**
         * 内容样式对象
         */
        contentStyle() {
            return {
                'padding-left': this.isTop ? '0' : '10px',
                marginRight: this.isTop
                    ? `${this.section.maxItemWidth - this.contentWidth}px`
                    : `${this.section.maxContentWidth - this.contentWidth}px`
            };
        },
        /**
         * 标签类对象
         */
        labelClassObject() {
            return ['label', this.labelClass];
        },
        /**
         * 内容类对象
         */
        contentClassObject() {
            return ['content', this.contentClass];
        }
    },
    /**
     * 组件渲染完成方法
     */
    mounted() {
        this.computeSize();
        const parent = this.getParent();
        parent.addItem(this);
    },
    /**
     * 组件更新方法
     */
    updated() {
        this.computeSize();
    },
    /**
     * 组件销毁方法
     */
    destroyed() {
        const parent = this.getParent();
        parent.removeItem(this);
    },
    methods: {
        /**
         * 获取子项的直接父级
         */
        getParent() {
            return this.isInGroup ? this.sectionGroup : this.section;
        },
        /**
         * 计算尺寸
         */
        computeSize() {
            if (this.$refs.label) {
                const rect = this.$refs.label.getBoundingClientRect();
                this.labelWidth = rect.width;
            }

            if (this.$refs.content) {
                const rect = this.$refs.content.getBoundingClientRect();
                this.contentWidth = rect.width;
            }

            if (!this.isAutoWidth && this.$refs.item) {
                const rect = this.$refs.item.getBoundingClientRect();
                this.itemWidth = rect.width;
            } else {
                this.itemWidth = this.isTop
                    ? Math.max(this.labelWidth, this.contentWidth)
                    : this.labelWidth + this.contentWidth;
            }
        },
        /**
         * 设置子项间距
         * @param gap
         */
        setColGap(gap) {
            this.colGap = gap;
        },
        /**
         * 设置子项行间距
         * @param gap
         */
        setRowGap(gap) {
            this.rowGap = gap;
        }
    }
};
</script>

<style lang="scss" scoped>
.section-item {
    display: flex;
    flex: none;
    overflow: hidden;

    .label {
        color: #606266;
    }

    .label,
    .content {
        flex: none;
    }
}
</style>
